import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateContentBuildEmailPreviewId = Brand<number, 'TemplateContentBuildEmailPreviewId'>;
export const TemplateContentBuildEmailPreviewId = createBranded<TemplateContentBuildEmailPreviewId>();
